import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import axios from "axios";
import { globalConfig } from "../../../config/config";
//import { useContentObjectContext } from "../contexts/ContentObjectContext";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
// const querystring = require("querystring");

const CreateContentIndices = () => {
  const [contentIndexTypes, setContentIndexTypes] = useState([]);
//   const {token,userMetadata}=useAuth()
//   const history = useHistory();
	const token = globalConfig.hardcoded_header;
  const [message, setMessage] = useState("");
//   const { currentContentObject } = useContentObjectContext();

  const [state, setState] = useState({
    contentIndexId: 0,
    contentId: 0, //currentContentObject,
    contentIndexTypeId: 0,
    contentIndexName: "",
    contentIndexDescr: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-indices`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-indices/contentIndexId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentIndexId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(response2.status + ":" + response2.data.contentIndexId);
          // && response2.data.contentFacadeId === this.state.contentFacadeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      console.log("message info - " + message);
      setState({ ...state, contentIndexName: "", contentIndexDescr: "" });
    });
  }
  function handleRest(event) {
    setState({ ...state, contentIndexName: "", contentIndexDescr: "" });
    this.contentObjectName = "";
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-index-types`,
         apiHeader(token)
      )
      .then((res) => {
        const contentIndexTypes = res.data;
        console.log(contentIndexTypes);
        setContentIndexTypes(contentIndexTypes);
      })
      .catch((x) => {
      });
  };

  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Index</h4>			
			<Link to="/breeze/list-content-indices">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            readOnly={true}
            id="content_id"
            className="form-control input-xlarge col-sm-8"
            value={state.contentId}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Index Type">
            Index Type
          </label>
          <select
            id="contentIndexTypeId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexTypeId}
            onChange={handleChange}
          >
            {/* <option value={state.contentIndexTypeId} onChange ={handleChange} className="form-control input-xlarge col-sm-8" /> */}

            <option>Select Index Type</option>
            {contentIndexTypes.map(
              ({ contentIndexTypeName, contentIndexTypeId }) => (
                <option key={contentIndexTypeId} value={contentIndexTypeId}>
                  {contentIndexTypeName}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Index Object">
            Index Object
          </label>
          <input
            id="contentIndexName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Description">
            Description
          </label>
          <textarea
            id="contentIndexDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexDescr}
            onChange={handleChange}
          />
        </div>
        <hr />
        <button className="btn btn-primary" value="Clear" onClick={handleRest}>
          Clear
        </button>
        &nbsp;
        <button
          className="btn btn-success"
          value="Create"
          onClick={handleSubmit}
        >
          Create
        </button>
      </div>
    </form>
  );
};

export default CreateContentIndices;
